module.exports = __webpack_public_path__ + "static/fire_wall-2acef841dda7324a656851a877142887.jpg";